import { ChangeDetectionStrategy, Component, EventEmitter, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { CONVERSATION_DATA_REDUCER } from '../../../../store/reducers/conversation-data.reducer';
import { combineLatest, Observable } from 'rxjs';
import { IContactDetails } from '../../../../shared/models/contact-details.model';
import { AsyncPipe } from '@angular/common';
import { TitlePipe } from './pipes/title.pipe';
import { ButtonModule } from 'primeng/button';
import { MessageService } from 'primeng/api';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';
import { IConversationDetails } from '../../../../shared/models/conversation-details.model';
import { IApiState } from '../../../../shared/models/api-state.model';
import { TRANSCRIPTION_REDUCER } from '../../../../store/reducers/transcription.reducer';

@Component({
  selector: 'cv-conversation-header',
  standalone: true,
  imports: [AsyncPipe, TitlePipe, ButtonModule, OverlayPanelModule],
  templateUrl: './conversation-header.component.html',
  styleUrl: './conversation-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ConversationHeaderComponent {
  @ViewChild('menuButtonOverlay') menuButtonOverlay!: OverlayPanel;
  @Output() readonly copyTranscript: EventEmitter<void> = new EventEmitter<void>();
  @Output() readonly downloadCallAudio: EventEmitter<void> = new EventEmitter<void>();
  @Output() readonly downloadConversationToPDF: EventEmitter<void> = new EventEmitter<void>();

  data$: Observable<IConversationHeaderComponentData> = combineLatest({
    contactDetails: this.store.select(CONVERSATION_DATA_REDUCER.selectContactDetails),
    conversationDetails: this.store.select(CONVERSATION_DATA_REDUCER.selectConversationDetails),
    hasTranscription: this.store.select(TRANSCRIPTION_REDUCER.hasAnyTranscription),
    audio: this.store.select(TRANSCRIPTION_REDUCER.selectAudio),
  });

  constructor(
    private readonly store: Store,
    private readonly toastService: MessageService,
  ) {}

  onCopyPageUrl(): void {
    void this.copyToClipboard(window.location.href, 'Page URL copied to clipboard');
  }

  onCopyTranscription(): void {
    this.copyTranscript.emit();
    this.menuButtonOverlay.hide();
  }

  onDownloadConversationToPDF(): void {
    this.downloadConversationToPDF.emit();
    this.menuButtonOverlay.hide();
  }

  private async copyToClipboard(textToCopy: string, successMessage: string): Promise<void> {
    await navigator.clipboard.writeText(textToCopy);
    this.toastService.add({
      severity: 'success',
      summary: 'Copied',
      detail: successMessage,
    });

    this.menuButtonOverlay.hide();
  }
}

export interface IConversationHeaderComponentData {
  contactDetails: IApiState<IContactDetails>;
  conversationDetails: IApiState<IConversationDetails>;
  hasTranscription: boolean;
  audio: IApiState<string>;
}
